import { combineReducers } from 'redux';

import liveReducer from './liveReducer';
import matchReducer from './matchReducer';

export default combineReducers({
  live: liveReducer,
  match: matchReducer,
});
